import { decomposeColor } from "./color-manipulator";

export function getAccessibleTextColor(color = '') {
    if(!color) return
    const decomposedColor = decomposeColor(color)
    if (decomposedColor.values.length !== 3) {
        console.error('Could not determine color')
    }
    /*
    Based on codepen: https://codepen.io/davidhalford/pen/ywEva
    Quoting from this W3C document: http://www.webmasterworld.com/r.cgi?f=88&d=9769&url=http://www.w3.org/TR/AERT#color-contrast
    
    Color brightness is determined by the following formula: 
    ((Red value X 299) + (Green value X 587) + (Blue value X 114)) / 1000    
    */
    let brightnessMapping = {
        0: 299,
        1: 587,
        2: 114
    }

    const threshold = 130; /* about half of 256. Lower threshold equals more dark text on dark background  */
    let brightnessArray = []
    decomposedColor.values.forEach((val, index) => {
        let multiplier = brightnessMapping[index]
        if (multiplier !== undefined) {
            brightnessArray.push(multiplier * val)
        }
    })

    const colorBrightness = (brightnessArray.reduce((a, b) => a + b, 0)) / 1000;
    if (colorBrightness > threshold) {
        return "#000000"
    }

    return "#ffffff"
}